import { ManualUsageEvent } from "../../api/models";
import { FormGroup } from "@angular/forms";
import { UsageEventBase } from "src/app/ltb-usage/models/usageEventBase";
import { UsageEvent } from "src/app/ltb-usage/models/usageEvent";
import { LateFunding } from "src/app/ltb-usage/models/lateFundingEvent";
import { LateUtilityFeeAdjustment } from "src/app/ltb-usage/models/lufaEvent";
import { OpenClose } from "src/app/ltb-usage/models/OpendCloseEvent";
import { UsageType } from "src/app/ltb-usage/models/usageEventType";


export class ManualFormMapper {

  static MapFromManualUsageEvent(data: ManualUsageEvent, formGroup?: FormGroup): FormGroup {
    //console.log("mapping: ", data);

    Object.keys(formGroup.controls).forEach( key => {
      if(formGroup.controls[key] instanceof FormGroup) {
        // Gotta dig depper into this nested FormGroup
        this.MapFromManualUsageEvent(data, formGroup.controls[key] as FormGroup);
      }
      else if(data[key]) {
        // Map the existing property
        switch(key)
        {
          case "month":
            formGroup.controls[key].setValue(data[key] - 1);
            break;
          case "dateRequested":
            formGroup.controls[key].setValue(data[key].split('T')[0]); //Populating DateRequested
            break;
          case "value":
            formGroup.controls[key].setValue(data[key]);
            formGroup.controls[key].markAllAsTouched();
          default:
            formGroup.controls[key].setValue(data[key]);
            break;
        }
      } else {
        //console.log("could not find value for key: ", key);
      }
    });
    return formGroup
  }

  static MapToManualUsageEvent(formGroup: FormGroup): UsageEventBase {

    if (formGroup.get('usageType').value === UsageType.base) {
      return new UsageEvent(formGroup);
    }

    if (formGroup.get('usageType').value === UsageType.lateFunding) {
      return new LateFunding(formGroup);
    }

    if (formGroup.get('usageType').value === UsageType.lateUtilityFundingAdjustment) {
      return new LateUtilityFeeAdjustment(formGroup);
    }

    if (formGroup.get('usageType').value === UsageType.openClose) {
      return new OpenClose(formGroup);
    }
  }

}
